import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { cldOpt } from "../lib/img";

export const WHOLESALE_CARDS = [
  { slug: "moissanite-watches-wholesale", eyebrow: "Bulk Timepieces", title: "Moissanite Watches Wholesale", cta: "Get watch pricing" },
  { slug: "moissanite-cuban-chains-wholesale", eyebrow: "Bulk Chains", title: "Cuban Link Wholesale", cta: "Get chain pricing" },
  { slug: "moissanite-teeth-grillz-wholesale", eyebrow: "Bulk Grillz", title: "Teeth Grillz Wholesale", cta: "Get grillz pricing" },
];

export const WholesaleCards = () => {
  const [images, setImages] = useState({});
  useEffect(() => {
    api.get("/site/home-wholesale").then((r) => setImages(r.data.images || {})).catch(() => {});
  }, []);

  return (
    <section className="bg-white" data-testid="home-wholesale-section">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-24">
        <p className="text-xs font-bold uppercase tracking-[0.4em] text-[#1e40af]">Wholesale</p>
        <h2 className="mt-3 font-display text-3xl font-black tracking-tighter text-black sm:text-4xl">
          Buy In Bulk. Stock The Ice.
        </h2>
        <p className="mt-3 max-w-xl text-sm text-zinc-600">
          Factory-direct moissanite pricing for retailers, jewelers and resellers.
        </p>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {WHOLESALE_CARDS.map((c) => (
            <Link
              key={c.slug}
              to={`/${c.slug}`}
              data-testid={`home-wholesale-card-${c.slug}`}
              className="group relative block aspect-[4/5] overflow-hidden border-2 border-black bg-black transition-transform duration-300 hover:-translate-y-1 hover:shadow-[8px_8px_0_#1e40af]"
            >
              {images[c.slug] && (
                <img
                  src={cldOpt(images[c.slug], 800)}
                  alt={c.title}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 h-full w-full object-cover opacity-80 transition-[transform,opacity] duration-500 group-hover:scale-105 group-hover:opacity-100"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-white/70">{c.eyebrow}</p>
                <h3 className="mt-2 font-display text-2xl font-black uppercase leading-tight tracking-tight text-white sm:text-3xl">
                  {c.title}
                </h3>
                <span className="mt-4 inline-flex items-center gap-2 border-b-2 border-white pb-1 text-xs font-bold uppercase tracking-widest text-white">
                  {c.cta} <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
